import { render, staticRenderFns } from "./ChooseCardList.vue?vue&type=template&id=032273a0"
import script from "./ChooseCardList.vue?vue&type=script&lang=js"
export * from "./ChooseCardList.vue?vue&type=script&lang=js"
import style0 from "./ChooseCardList.vue?vue&type=style&index=0&id=032273a0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports